import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cf78d75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-lg container-fluid py-3 create_needs" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section border p-3" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "text-primary" }, "Create a Need"),
  /*#__PURE__*/_createElementVNode("small", null, "Articulately populate needs related to your health directorate to help innovators identify areas to innovate")
], -1))
const _hoisted_3 = { class: "py-4" }
const _hoisted_4 = { class: "my-3 d-none" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Draft", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreateNeeds = _resolveComponent("CreateNeeds", true)!
  const _component_List = _resolveComponent("List")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_CreateNeeds)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_List, { data: _ctx.data }, null, 8, ["data"]),
      _createVNode(_component_router_link, {
        class: "text-decoration-underline",
        to: "#"
      }, {
        default: _withCtx(() => [
          _createTextVNode("View draft")
        ]),
        _: 1
      })
    ])
  ]))
}